const Colors = {
    headerNavigationRed: '#e2211c',
    headerNavigationRed2: '#c73420',
    sidebarNavigationRed: '#8e1b1c',
    backgroundGray: '#737373',
    backgroundRed: '#751517',
    backgroundWhite: '#FFFFFF',
    backgroundBlue: '#092041',
    footerRed: '#D0021B',
    tiers: {
        tier1: '#ECECEC',
        tier2: '#C8C8C8',
        tier3: '#807F83',
        defaultRed: '#7F0211',
        defaultGray: '#737373',
        defaultBlue: '#092041',
        defaultWhite: '#FFFFFF',
    },
    loader: '#ECECEC',
    loaderHighlight: '#C8C8C8',
    fontGray: '#737373',
    fontWhite: '#FFFFFF'
};

export default Colors;
